import UploadFile from "@components/public/uploadFile";
import { ActionIcon } from "@mantine/core";
import { useMutation } from "@tanstack/react-query";
import Common from "@utilities/common";
import { FC } from "react";
import { IoMdRemoveCircle } from "react-icons/io";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";

interface Props {
    data: IArticle["get"];
}

const Banner: FC<Props> = ({ data }) => {
    const { pathname } = useLocation();

    const [URLSearchParams] = useSearchParams();

    const Navigate = useNavigate();

    const { mutate, isLoading } = useMutation(
        ["removeArticleImage"],
        (id: number) =>
            Common.api.articles.DeleteBanner({
                id: id,
            }),
        {
            onSuccess: () => {
                URLSearchParams.set("refetch", "true");

                Navigate(
                    {
                        pathname,
                        search: "?" + URLSearchParams.toString(),
                    },
                    {
                        replace: true,
                    },
                );
            },
        },
    );

    const handleRemove = (id: number) => {
        mutate(id);
    };

    return (
        <div>
            {data.banner && (
                <img
                    className="max-w-lg mx-auto block"
                    src={data.banner || ""}
                    alt={data.title}
                />
            )}

            <div className="flex items-end">
                <div className="flex-1 ml-4">
                    <UploadFile
                        id={data?.id?.toString()}
                        name={data.url}
                        type="image"
                        fileSetings={{
                            accept: "image/jpg,image/jpeg,image/webp,image/png",
                            aspectRatio: 4 / 3,
                            maximumSize: 2048000,
                        }}
                        repository="articleBanner"
                        inputProps={{
                            label: "تصویر اصلی",
                            value: "",
                            errors: "",
                            placeholder: "تصویر اصلی",
                        }}
                        handleChange={() => {
                            URLSearchParams.set("refetch", "true");

                            Navigate(
                                {
                                    pathname,
                                    search: "?" + URLSearchParams.toString(),
                                },
                                {
                                    replace: true,
                                },
                            );
                        }}
                    />
                </div>

                <div>
                    <ActionIcon
                        variant="subtle"
                        color="red"
                        radius={9999}
                        className="mx-1"
                        size="lg"
                        loading={isLoading}
                        disabled={isLoading}
                        onClick={() => handleRemove(data.id)}>
                        <IoMdRemoveCircle className="text-2xl" />
                    </ActionIcon>
                </div>
            </div>
        </div>
    );
};

export default Banner;
